/**
 * Conversations Service
 *
 * Appends finalized voice turns to a question's unified voice+text
 * conversation thread — see EVT-120's questionConversation.ts on the API
 * side. Write-only: nothing reads the thread back over HTTP yet (see the
 * router's comment for why).
 */

import type { AppendTurnsRequest } from '@evaltick/shared';
import { BaseAPIClient, type RequestOptions } from './base';

export type { AppendTurnsRequest };

export class ConversationsService extends BaseAPIClient {
  async appendTurns(
    assessmentId: string,
    interviewTemplateItemId: string,
    request: AppendTurnsRequest,
    options?: RequestOptions
  ): Promise<void> {
    await this.post<void>(
      `/conversations/${assessmentId}/${interviewTemplateItemId}/turns`,
      request,
      options
    );
  }
}

export default ConversationsService;
